!function(){"use strict";var e={};function t(t){return e[t]}e.basic=[],e.light=[{featureType:"administrative",elementType:"labels",stylers:[{visibility:"simplified"},{lightness:"64"},{hue:"#ff0000"}]},{featureType:"administrative",elementType:"labels.text.fill",stylers:[{color:"#bdbdbd"}]},{featureType:"administrative",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"landscape",elementType:"all",stylers:[{color:"#f0f0f0"},{visibility:"simplified"}]},{featureType:"landscape.natural.landcover",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"landscape.natural.terrain",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"geometry.fill",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"labels",stylers:[{lightness:"100"}]},{featureType:"poi.park",elementType:"all",stylers:[{visibility:"on"}]},{featureType:"poi.park",elementType:"geometry",stylers:[{saturation:"-41"},{color:"#e8ede7"}]},{featureType:"poi.park",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"all",stylers:[{saturation:"-100"}]},{featureType:"road",elementType:"labels",stylers:[{lightness:"25"},{gamma:"1.06"},{saturation:"-100"}]},{featureType:"road.highway",elementType:"all",stylers:[{visibility:"simplified"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{gamma:"10.00"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{weight:"0.01"},{visibility:"simplified"}]},{featureType:"road.highway",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"road.highway",elementType:"labels.text.fill",stylers:[{weight:"0.01"}]},{featureType:"road.highway",elementType:"labels.text.stroke",stylers:[{weight:"0.01"}]},{featureType:"road.arterial",elementType:"geometry.fill",stylers:[{weight:"0.8"}]},{featureType:"road.arterial",elementType:"geometry.stroke",stylers:[{weight:"0.01"}]},{featureType:"road.arterial",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"road.local",elementType:"geometry.fill",stylers:[{weight:"0.01"}]},{featureType:"road.local",elementType:"geometry.stroke",stylers:[{gamma:"10.00"},{lightness:"100"},{weight:"0.4"}]},{featureType:"road.local",elementType:"labels",stylers:[{visibility:"simplified"},{weight:"0.01"},{lightness:"39"}]},{featureType:"road.local",elementType:"labels.text.stroke",stylers:[{weight:"0.50"},{gamma:"10.00"},{lightness:"100"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"water",elementType:"all",stylers:[{color:"#cfe5ee"},{visibility:"on"}]}],e.white_label=[{featureType:"all",elementType:"all",stylers:[{visibility:"simplified"}]},{featureType:"all",elementType:"labels",stylers:[{visibility:"simplified"}]},{featureType:"administrative",elementType:"labels",stylers:[{gamma:"3.86"},{lightness:"100"}]},{featureType:"administrative",elementType:"labels.text.fill",stylers:[{color:"#cccccc"}]},{featureType:"landscape",elementType:"all",stylers:[{color:"#f2f2f2"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"all",stylers:[{saturation:-100},{lightness:45}]},{featureType:"road.highway",elementType:"all",stylers:[{visibility:"simplified"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{weight:"0.8"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{weight:"0.8"}]},{featureType:"road.highway",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"road.highway",elementType:"labels.text.fill",stylers:[{weight:"0.8"}]},{featureType:"road.highway",elementType:"labels.text.stroke",stylers:[{weight:"0.01"}]},{featureType:"road.arterial",elementType:"geometry.stroke",stylers:[{weight:"0"}]},{featureType:"road.arterial",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"road.local",elementType:"geometry.stroke",stylers:[{weight:"0.01"}]},{featureType:"road.local",elementType:"labels.text",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"water",elementType:"all",stylers:[{color:"#e4e4e4"},{visibility:"on"}]}],e.dark_label=[{featureType:"all",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"all",elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#000000"},{lightness:40}]},{featureType:"all",elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#000000"},{lightness:16}]},{featureType:"all",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#000000"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#000000"},{lightness:17},{weight:1.2}]},{featureType:"administrative",elementType:"labels",stylers:[{visibility:"simplified"},{lightness:"-82"}]},{featureType:"administrative",elementType:"labels.text.stroke",stylers:[{invert_lightness:!0},{weight:"7.15"}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#000000"},{lightness:20}]},{featureType:"landscape",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#000000"},{lightness:21}]},{featureType:"road",elementType:"labels",stylers:[{visibility:"simplified"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#000000"},{lightness:17},{weight:"0.8"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#000000"},{lightness:29},{weight:"0.01"}]},{featureType:"road.highway",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#000000"},{lightness:18}]},{featureType:"road.arterial",elementType:"geometry.stroke",stylers:[{weight:"0.01"}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#000000"},{lightness:16}]},{featureType:"road.local",elementType:"geometry.stroke",stylers:[{weight:"0.01"}]},{featureType:"road.local",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#000000"},{lightness:19}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#000000"},{lightness:17}]}];

const l={};

function s(e={}){if(e.type||(e.type="json"),e.url)return l[e.url]?l[e.url]:function(e,t){const s=new Promise(((l,s)=>{"text"===t?fetch(e).then((e=>e.text())).then((e=>{l(e)})).catch((e=>{s(e)})):function(e,t,l){let s=document.getElementsByTagName("head")[0],i=!1,r=document.createElement("script");r.src=e,r.onload=r.onreadystatechange=function(){i||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState?l():(i=!0,t())},s.appendChild(r)}(e,(function(){l()}),(function(){s()}))}));return l[e]=s,s}(e.url,e.type);if(e.json)return l[e.json]?Promise.resolve(l[e.json]):window.fetch(e.json).then((e=>e.json())).then((t=>(l[e.json]=t,t)));if(e.name){const t="".concat(e.name,e.version);return l[t]?l[t]:function(e){const t="".concat(e.name,e.version),s=new Promise(((t,l)=>{try{window.Shopify.loadFeatures([{name:e.name,version:e.version,onLoad:e=>{!function(e,t,l){l?t(l):e()}(t,l,e)}}])}catch(e){l(e)}}));return l[t]=s,s}(e)}return Promise.reject()}

function geocodeAddress(address){
  return new Promise((resolve,reject)=>{
    new google.maps.Geocoder().geocode({address},(results,status)=>{
      if(status==="OK"){
        resolve({lat:results[0].geometry.location.lat(),lng:results[0].geometry.location.lng()});
      } else {
        reject(status);
      }
    });
  });
}

function loadMapAPI(key){
  if(null===window.theme.mapAPI){
    const url=`https://maps.googleapis.com/maps/api/js?key=${key}`;
    window.theme.mapAPI=s({url});
  }
  return window.theme.mapAPI;
}

function buildInfoWindowContent({name, addressText, hours, bookUrl}){
  return `
    <div class="map-info-window">
      ${name ? `<h3 class="heading-small">${name}</h3>` : ''}
      ${addressText ? `<div class="hero__subheading hero__hours">${addressText}</div>` : ''}
      ${hours ? `<div class="hero__subheading hero__hours">${hours}</div>` : ''}
      ${bookUrl ? `<a class="btn btn--solid  btn--primary" href="${bookUrl}" rel="noopener" style="display:inline-block;">Book Now</a>` : ''}
    </div>
  `;
}

window.theme.mapAPI=window.theme.mapAPI||null;

customElements.get("map-component")||customElements.define("map-component",class extends HTMLElement{
  constructor(){
    super();
    this.key=this.getAttribute("data-api-key");
    this.styleString=this.getAttribute("data-style")||"";
    this.zoomString=this.getAttribute("data-zoom")||14;
    // Address 1
    this.address=this.getAttribute("data-address");
    this.enableCorrection=this.getAttribute("data-latlong-correction");
    this.lat=this.getAttribute("data-lat");
    this.long=this.getAttribute("data-long");
    this.name=this.getAttribute("data-name");
    this.addressText=this.getAttribute("data-address-text");
    this.hours=this.getAttribute("data-hours");
    this.bookUrl=this.getAttribute("data-book-url");
    // Address 2
    this.address2=this.getAttribute("data-address-2");
    this.enableCorrection2=this.getAttribute("data-latlong-correction-2");
    this.lat2=this.getAttribute("data-lat-2");
    this.long2=this.getAttribute("data-long-2");
    this.name2=this.getAttribute("data-name-2");
    this.addressText2=this.getAttribute("data-address-text-2");
    this.hours2=this.getAttribute("data-hours-2");
    this.bookUrl2=this.getAttribute("data-book-url-2");
    // Custom marker icon
    this.markerIcon=this.getAttribute("data-marker-icon")||null;
  }

  connectedCallback(){this.key&&this.initMaps()}

  initMaps(){
    loadMapAPI(this.key).then(()=>{
      const resolve1=("true"===this.enableCorrection&&this.lat&&this.long)
        ?Promise.resolve(new google.maps.LatLng(this.lat,this.long))
        :geocodeAddress(this.address);

      const resolve2=this.address2
        ?("true"===this.enableCorrection2&&this.lat2&&this.long2)
          ?Promise.resolve(new google.maps.LatLng(this.lat2,this.long2))
          :geocodeAddress(this.address2)
        :null;

      return resolve2
        ?Promise.all([resolve1,resolve2])
        :resolve1.then(loc=>[loc]);
    }).then((locations)=>{
      const map=new google.maps.Map(this,{
        zoom:parseInt(this.zoomString,10),
        styles:t(this.styleString),
        center:locations[0],
        draggable:!0,
        clickableIcons:!1,
        scrollwheel:!1,
        zoomControl:!1,
        disableDefaultUI:!0
      });

      const infoWindow=new google.maps.InfoWindow();

      const locationMeta=[
        {name:this.name,  addressText:this.addressText,  hours:this.hours,  bookUrl:this.bookUrl},
        {name:this.name2, addressText:this.addressText2, hours:this.hours2, bookUrl:this.bookUrl2}
      ];

      const markerOptions=this.markerIcon?{map,icon:{url:this.markerIcon}}:{map};

      // Build markers array first so external card listeners can reference it
      const markers=[];

      locations.forEach((position, index)=>{
        const marker=new google.maps.Marker({...markerOptions, position});
        const meta=locationMeta[index];

        marker.addListener("click",()=>{
          infoWindow.setContent(buildInfoWindowContent(meta));
          infoWindow.open({anchor:marker, map, shouldFocus:false});
        });

        markers.push({marker, meta});
      });

      // Allow external .map__location elements to trigger a marker popup
      document.querySelectorAll(".map__location").forEach((el, index)=>{
        const entry=markers[index];
        if(!entry) return;

        el.addEventListener("click",()=>{
          infoWindow.setContent(buildInfoWindowContent(entry.meta));
          infoWindow.open({anchor:entry.marker, map, shouldFocus:false});
          map.panTo(entry.marker.getPosition());

          const mapEl = document.querySelector('#map-component');
          if (mapEl) {
            mapEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      if(locations.length>1){
        const bounds=new google.maps.LatLngBounds();
        locations.forEach(loc=>bounds.extend(loc));
        map.fitBounds(bounds);
      } else {
        const center=map.getCenter();
        google.maps.event.addDomListener(window,"resize",()=>{
          google.maps.event.trigger(map,"resize");
          map.setCenter(center);
        });
      }

      this.map=map;
    }).catch(e=>{
      console.log("Failed to load Google Map");
      console.log(e);
    });
  }

  disconnectedCallback(){
    void 0!==window.google&&google.maps.event.clearListeners(this.map,"resize");
  }
});}();